export class DestinationProviderAttributesAzure {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceGroup",
            "baseName": "resourceGroup",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DestinationProviderAttributesAzure.attributeTypeMap;
    }
    constructor() {
    }
}
